import * as moment from "moment"
import { DEPARTMENTS } from "../constants/constants"

export const addCommas = number => {
  number += ""
  let parts = number.split(".")
  let integer = parts[0]
  let decimal = parts.length > 1 ? "." + parts[1] : ""
  let rgx = /(\d+)(\d{3})/
  while (rgx.test(integer)) {
    integer = integer.replace(rgx, `$1,$2`)
  }
  return integer + decimal
}

export const formatName = (contact, honorific = "") => {
  if (contact.name && (contact.company || contact.company_name))
    return `${contact.company || contact.company_name} ${
      contact.name
    } ${honorific}`
  else if (contact.name) return contact.name + " " + honorific
  else return (contact.company || contact.company_name) + " " + honorific
}

export const formatProfile = item => {
  let date = "",
    company = "",
    honorific = ""
  date =
    moment(
      item.relocation_at.date ? item.relocation_at.date : item.relocation_at
    ).format("YYYY年MM月") + "に"

  if (item.honorific === "退任" || item.honorific.indexOf("当社") !== -1) {
    company = ""
  } else {
    company = item.company_name + "の"
  }

  if (
    item.honorific.indexOf("退任") !== -1 ||
    item.honorific.indexOf("入社") !== -1 ||
    item.honorific.indexOf("就任") !== -1 ||
    item.honorific.indexOf("着任") !== -1
  ) {
    honorific = item.honorific
  } else {
    honorific = item.honorific + "に着任"
  }

  return date + company + honorific + "。"
}

export const formatSeoProfile = item => {
  return `現職：${item.company_name}の${item.honorific} ${item.name} | キーマンレターなら34万人以上のコンタクトの取りづらい大企業の決裁者を企業、部門、役職、経歴などからリスト化してレターでコンタクトが取れます。`
}

export const formatPersonalProfile = item => {
  let name = "",
    birthday = "",
    from = "",
    educationalBackgroundText = "",
    educationalBackground = []

  if (item.furigana) {
    name = `${item.name}（${item.furigana}）様は`
  }
  if (item.birthday) {
    birthday = moment(item.birthday).format("YYYY年MM月DD日生まれ。")
  }
  if (item.from) {
    from = `${item.from}出身。`
  }

  // 学歴
  if (item.junior_high_school) {
    educationalBackground.push(item.junior_high_school)
  }
  if (item.high_school) {
    educationalBackground.push(item.high_school)
  }
  if (item.technical_college) {
    educationalBackground.push(item.technical_college)
  }
  if (item.professional_school) {
    educationalBackground.push(item.professional_school)
  }
  if (item.university) {
    educationalBackground.push(item.university)
  }
  if (item.grad_school) {
    educationalBackground.push(item.grad_school)
  }
  if (educationalBackground.length > 0) {
    educationalBackgroundText = educationalBackground.join("、") + "を卒業。"
  }

  let profile = ""
  if (birthday || from || educationalBackgroundText) {
    // 注：ふりがなだけの場合は情報量が少ないため条件から外している
    profile = name + birthday + from + educationalBackgroundText
  }

  return profile
}

export const stripDomain = url => {
  return url
    .replace("http://", "")
    .replace("https://", "")
    .replace("www.", "")
    .split(/[/?#]/)[0]
}

export const getQueryVariable = (q = "", variable = "") => {
  let query = q[0] === "?" ? q.substring(1) : q
  let vars = query.split("&")

  let queryObj = {}

  for (let i in vars) {
    let pair = vars[i].split("=")

    if (pair.length === 2) {
      let key = decodeURIComponent(pair[0])
      let value = decodeURIComponent(pair[1])

      if (Array.isArray(variable)) {
        if (variable.find(v => v === key)) {
          queryObj[key] = value
        }
      } else {
        queryObj[key] = value
      }
    }
  }

  if (typeof variable === "string") {
    return queryObj[variable]
  } else {
    return queryObj
  }
}

/**
 * 日本語単位でフォーマットする
 * @param {number} num
 * @param {bool} truncate 最後に出た単位以下を切り捨てる
 * @return {string}
 */
export const formatJPNumberUnit = (num, truncate = true) => {
  const kName = [
    "万",
    "億",
    "兆",
    "京",
    "垓",
    "杼",
    "穰",
    "溝",
    "澗",
    "正",
    "載",
    "極",
  ]
  const str = String(num)
  let n = ""
  let count = 0
  let ptr = 0

  for (var i = str.length - 1; i >= 0; i--) {
    n = str.charAt(i) + n
    count++
    if (count % 4 === 0 && i !== 0) {
      n = kName[ptr++] + n
    }
  }

  if (truncate) {
    // 最後に出る単位以下を切り捨てる
    for (var j = n.length - 1; j >= 0; j--) {
      if (kName.indexOf(n.charAt(j)) !== -1) {
        n = n.slice(0, j + 1)
        break
      }
    }

    // 最後の単位から次の単位までが0000の場合は切り捨てる
    let complete = false
    while (!complete) {
      if (n.length < 5) {
        // xxxx万などのように単位が１つしかない場合は切り捨てられないためスキップ
        complete = true
        break
      }

      if (n.substring(n.length - 1, n.length - 5) === "0000") {
        n = n.slice(0, n.length - 5)
      } else {
        complete = true
      }
    }
  }

  return n
}

export const formatDepartment = honorific => {
  // デフォルトに「その他」とする
  let department = "その他"

  for (let i in DEPARTMENTS) {
    let keywords = DEPARTMENTS[i].name.split("・")
    for (let j in keywords) {
      if (honorific.includes(keywords[j])) {
        // 管理の場合は品質管理を除外
        if (DEPARTMENTS[i].name === "管理") {
          if (honorific.includes("品質管理")) {
            department = "品質管理"
            break
          }
        }

        // 営業の場合は営業企画・営業推進を除外
        if (DEPARTMENTS[i].name === "営業") {
          if (honorific.includes("営業企画")) {
            department = "営業企画"
            break
          }

          if (honorific.includes("営業推進")) {
            department = "営業推進"
            break
          }
        }

        // 人事の場合は法人事業、個人事業を除外
        if (DEPARTMENTS[i].name === "人事") {
          if (honorific.includes("法人事業")) {
            continue
          }

          if (honorific.includes("個人事業")) {
            continue
          }
        }

        // 経理・財務の場合、中国の現地法人で役職がある方で「有限公司総経理」のように表記されるケースを除外
        if (DEPARTMENTS[i].name === "経理・財務") {
          if (honorific.includes("公司総経理")) {
            continue
          }
        }

        // 企画の場合、「経営企画」と「営業企画」を除外
        if (DEPARTMENTS[i].name === "企画") {
          if (honorific.includes("経営企画")) {
            department = "経営企画"
            break
          }

          if (honorific.includes("営業企画")) {
            department = "営業企画"
            break
          }
        }

        // 開発の場合、「商品開発」と「研究開発」を除外
        if (DEPARTMENTS[i].name === "開発") {
          if (honorific.includes("商品開発")) {
            department = "商品開発"
            break
          }

          if (honorific.includes("研究開発")) {
            department = "研究開発"
            break
          }
        }

        department = DEPARTMENTS[i].name
        break
      }
    }
  }

  return department
}

export const formatPercentage = floatNumber => {
  return Number.parseFloat(floatNumber * 100).toFixed(2) + "%"
}
